var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.293 28H25.7181V30.8H14.293V28Z",
    fill: "url(#paint0_linear_91_6523)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1489 33.5996H22.8615V36.3996H17.1489V33.5996Z",
    fill: "url(#paint1_linear_91_6523)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85741 16.8004C5.48868 16.8004 -0.30869 16.8004 0.0128934 16.8004V19.6004H3.18227L8.18074 39.2H5.72544V42H34.2875V39.2H31.8328L36.8313 19.6004H40V16.8004C39.74 16.8004 32.7155 16.8004 32.8593 16.8004V12.0208L29.6746 8.89888L27.6551 10.8785L30.003 13.1802V16.8004H25.5884C25.1063 13.4958 22.9348 10.7248 19.9546 9.34893C20.8677 8.35423 21.4398 7.05252 21.4398 5.61221C21.4398 2.51763 18.8715 0 15.7147 0C12.5579 0 9.98962 2.51763 9.98962 5.61221C9.98962 7.05338 10.5623 8.35594 11.4763 9.35081C8.50674 10.7264 6.34223 13.4939 5.85741 16.8004ZM28.8887 39.2H11.1249L6.12658 19.601C6.67139 19.601 29.6958 19.6005 33.8872 19.6004L28.8887 39.2ZM12.8459 5.61221C12.8459 4.06185 14.1332 2.79995 15.7147 2.79995C17.2963 2.79995 18.5835 4.06185 18.5835 5.61221C18.5835 7.05113 17.456 8.39997 15.6224 8.41533C14.0844 8.36628 12.8459 7.13156 12.8459 5.61221ZM15.7876 11.2172C19.2013 11.2521 22.0497 13.6394 22.7032 16.8004H8.74087C9.36481 13.7731 12.0275 11.2687 15.7876 11.2172Z",
    fill: "url(#paint2_linear_91_6523)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_6523",
    x1: 19.7001,
    y1: 24.9462,
    x2: 20.2058,
    y2: 30.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_91_6523",
    x1: 19.8525,
    y1: 30.5459,
    x2: 20.8372,
    y2: 35.6916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_91_6523",
    x1: 18.9307,
    y1: -45.807,
    x2: 47.0119,
    y2: 22.6957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.50ec31314c067b8230171b8643894ee6.svg";
export { ForwardRef as ReactComponent };